module.exports = __webpack_public_path__ + "img/white-desktop.a31d978e.png";